import { render, staticRenderFns } from "./couponBar.vue?vue&type=template&id=17815212&scoped=true"
import script from "./couponBar.vue?vue&type=script&lang=js"
export * from "./couponBar.vue?vue&type=script&lang=js"
import style0 from "./couponBar.vue?vue&type=style&index=0&id=17815212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17815212",
  null
  
)

export default component.exports